import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center timeout-box",
  style: {"padding":"15px"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "Session Auto-Timeout", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-muted" }, "Your session will be cleared once the time below reaches 0.", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = { class: "router-view container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_idle = _resolveComponent("v-idle")!
  const _component_NavBar = _resolveComponent("NavBar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.loggedIn && _ctx.showPrompt)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _hoisted_3,
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showPrompt = false)),
            class: "btn btn-danger btn-lg"
          }, "Stay Logged In"),
          _hoisted_4
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.loggedIn)
        ? (_openBlock(), _createBlock(_component_v_idle, {
            key: 0,
            onIdle: _ctx.onidle,
            onRemind: _ctx.onremind,
            loop: true,
            reminders: [60, 120],
            wait: 5,
            duration: _ctx.sessionTimeout
          }, null, 8, ["onIdle", "onRemind", "duration"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_NavBar),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_router_view)
    ]),
    _createVNode(_component_Footer)
  ], 64))
}